import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  notAvailableHeader: {
    id: 'm.notAvailableHeader',
    defaultMessage: 'Oops! This offer is mobile only.',
  },
  notAvailableBody: {
    id: 'm.notAvailableBody',
    defaultMessage:
      'Go to the same link on a mobile device to get your free trial of Pandora Premium.',
  },
} as const);
